import type { SubscriptionInput, SubscriptionItem } from '@/types/subscription'

export async function apiGetSubscriptions(query?: string): Promise<SubscriptionItem[]> {
  const url = query?.trim()
    ? `/api/community/subscriptions?q=${encodeURIComponent(query.trim())}`
    : '/api/community/subscriptions'

  const res = await fetch(url, {
    method: 'GET',
    cache: 'no-store',
  })

  if (!res.ok) throw new Error('No se pudieron cargar las suscripciones')
  const json = await res.json()
  return Array.isArray(json?.subscriptions) ? json.subscriptions : []
}

export async function apiCreateSubscription(payload: SubscriptionInput) {
  const res = await fetch('/api/community/subscriptions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })

  const json = await res.json().catch(() => null)

  if (!res.ok) {
    throw new Error(json?.error || 'No se pudo crear la suscripción')
  }

  return json
}

export async function apiUpdateSubscription(
  recurringId: number,
  payload: Partial<SubscriptionInput>
) {
  const res = await fetch(`/api/community/subscriptions/${recurringId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  })

  const json = await res.json().catch(() => null)

  if (!res.ok) {
    throw new Error(json?.error || 'No se pudo actualizar la suscripción')
  }

  return json
}